import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#61a229",
        secondary: "#500878"
      },
      dark: {
        primary: "#61a229",
        secondary: "#500878"
      }
    }
  }
});
